import { render, staticRenderFns } from "./_SurveyItem.vue?vue&type=template&id=1a8191e3&"
import script from "./_SurveyItem.vue?vue&type=script&lang=js&"
export * from "./_SurveyItem.vue?vue&type=script&lang=js&"
import style0 from "./_SurveyItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports